function checkBreakpoints() {
    const windowWidth = window.innerWidth;
    this.isInSmallFormat = this.isFormat(this.breakpoints.smallFormat, windowWidth);
    this.isInMediumFormat = this.isFormat(this.breakpoints.mediumFormat, windowWidth);
    this.isInLargeFormat = this.isFormat(this.breakpoints.largeFormat, windowWidth);
    this.isInMediumFormatGlobalHeader = this.isFormat(this.breakpoints.globalHeaderMf, windowWidth);
    this.isInMediumFormatPortrait = this.isFormat(this.breakpoints.mediumFormatPortrait, windowWidth);
    this.isInGreaterThanMediumFormatLandscape = this.isFormat(this.breakpoints.greaterThanMediumFormatLandscape, windowWidth);
    this.currentFormat = this.getFormat();
}

// service for checking breakpoints (old browsers compatible)
// we don't sync css breakpoing for performance issues
// you need to manually change css breakpoints when you updates the javascript one
function BreakpointsService($rootScope) {
    this._smallFormatBreakpoint = 768;
    this._mediumFormatLandscapeBreakpoint = 1024;
    this._mediumFormatBreakpoint = 1270;
    this._mediumFormatGlobalHeaderBreakpoint = 950;

    this._smallFormatBreakpointSm = 320;
    this._smallFormatBreakpointMd = 500;
    this._smallFormatBreakpointLg = 630;

    this.breakpoints = {
        smallFormat: {
            min: 0,
            max: this._smallFormatBreakpoint,
        },
        mediumFormat: {
            min: this._smallFormatBreakpoint,
            max: this._mediumFormatBreakpoint,
        },
        largeFormat: {
            min: this._mediumFormatBreakpoint,
            max: Number.MAX_VALUE,
        },

        globalHeaderMf: {
            min: this._smallFormatBreakpoint,
            max: this._mediumFormatGlobalHeaderBreakpoint,
        },

        checkoutMlf: {
            min: this._mediumFormatLandscapeBreakpoint,
            max: this._mediumFormatBreakpoint,
        },
        checkoutMf: {
            min: this._smallFormatBreakpoint,
            max: this._mediumFormatLandscapeBreakpoint,
        },
        checkoutSf: {
            min: 0,
            max: this._smallFormatBreakpoint,
        },
        mediumFormatPortrait: {
            min: this._smallFormatBreakpoint,
            max: this._mediumFormatLandscapeBreakpoint,
        },
        greaterThanMediumFormatLandscape: {
            min: (this._mediumFormatLandscapeBreakpoint + 1),
            max: Number.MAX_VALUE,
        },
    };

    this.isInSmallFormat = false;
    this.isInMediumFormat = false;
    this.isInLargeFormat = false;
    this.isInMediumFormatGlobalHeader = false;
    this.isInMediumFormatPortrait = false;
    this.isInGreaterThanMediumFormatLandscape = false;

    $rootScope.$on('window:resize', () => {
        checkBreakpoints.call(this);
    });

    checkBreakpoints.call(this);
}

BreakpointsService.prototype.isFormat = function (format, windowWidth) {
    windowWidth = windowWidth === undefined ? window.innerWidth : windowWidth;

    return (format.min <= windowWidth && windowWidth < format.max);
};

BreakpointsService.prototype.isSmallFormat = function () {
    return this.isInSmallFormat;
};

BreakpointsService.prototype.isMediumFormat = function () {
    return this.isInMediumFormat;
};

BreakpointsService.prototype.isLargeFormat = function () {
    return this.isInLargeFormat;
};

BreakpointsService.prototype.MediumFormatGlobalHeader = function () {
    return this.isInMediumFormatGlobalHeader;
};

BreakpointsService.prototype.getFormat = function () {
    return this.isInSmallFormat ? 'SmallFormat' : (this.isInMediumFormat ? 'MediumFormat' : 'LargeFormat');
};

BreakpointsService.prototype.getDeviceDisplayFormatString = function () {
    if (this.isInSmallFormat) {
        return 'SF';
    }
    if (this.isInMediumFormat) {
        return 'MF';
    }
    if (this.isInLargeFormat) {
        return 'LF';
    }

    return '';
};

module.exports = BreakpointsService;



// WEBPACK FOOTER //
// ./src/common/breakpoints/breakpoints.service.js